import { BomContainer } from "../../controls/Bom/BomContainer";
import { SummaryContainer } from "../../controls/Summary/SummaryContainer";

import React, { Fragment, JSX, Suspense, useState } from "react";
import { useTranslation } from "react-i18next";

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Tab,
  Tabs,
} from "@mui/material";

enum TabIndex {
  BomDisplay,
  SummaryDisplay,
}

export function BomAndSummaryDialog({
  open,
  handleClose,
}: {
  open: boolean;
  handleClose: () => void;
}): JSX.Element {
  const [tabId, setTabId] = useState(TabIndex.BomDisplay);
  const { t } = useTranslation();

  console.log("tabId = ", tabId);

  return (
    <Dialog onClose={handleClose} open={open} maxWidth="xl" fullWidth>
      <DialogContent sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Suspense>
          <Box sx={{ height: "75vh" }}>
            <Tabs
              value={tabId}
              onChange={(e, tabId) => setTabId(tabId)}
              aria-label="basic tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label={t("AS:tab.billOfMaterials.title")}
                value={TabIndex.BomDisplay}
              />
              <Tab
                label={t("tab.configurationSummary.title")}
                value={TabIndex.SummaryDisplay}
              />
            </Tabs>
            <TabPanel value={tabId} index={TabIndex.BomDisplay}>
              <>{tabId === 0 && <BomContainer />}</>
            </TabPanel>
            <TabPanel value={tabId} index={TabIndex.SummaryDisplay}>
              <>{tabId === 1 && <SummaryContainer />}</>
            </TabPanel>
          </Box>
        </Suspense>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

function TabPanel(props: {
  value: number;
  index: TabIndex;
  children: JSX.Element;
}): JSX.Element {
  const { children, value, index } = props;

  if (value !== index) {
    return <Fragment />;
  }

  return (
    <Box role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </Box>
  );
}
